import EnergyBalance from './EnergyBalance';

export default EnergyBalance;
